import react, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Checkbox,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import SelectedRow from "./SelectedRow";

const SelectedTable = () => {
  const dispatch = useDispatch();
  const rows = useSelector((state) => state.ReceiptReducer.orders);

  if (rows.length)
    return (
      <TableContainer
        component={Paper}
        sx={{ backgroundColor: "pallete.primary" }}
      >
        <Table size="small">
          <TableHead>
            <TableRow variant="head">
              <TableCell align="justify">نام پزشک</TableCell>
              <TableCell align="justify">به نام</TableCell>
              <TableCell align="justify">نوع کار</TableCell>
              <TableCell align="justify">تعداد واحد</TableCell>
              <TableCell align="justify">تاریخ اتمام</TableCell>
              <TableCell align="justify" />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <SelectedRow
                orderId={row.orderId}
                doctorName={row.doctorName}
                patientName={row.patientName}
                orderType={row.orderTypeName}
                endDate={row.endDate}
                unitCount={row.unitCount}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  else return <></>;
};

export default SelectedTable;
